/* eslint-disable implicit-arrow-linebreak */
import { useQuery } from '@tanstack/react-query';

import SettingsService from 'src/services/settings.service';

// eslint-disable-next-line no-unused-vars
export const useSettings = (params: { companyId: string }) => {
  const result = useQuery({
    queryKey: ['settings'],
    queryFn: () => SettingsService.getSettings(params),
    enabled: true,
  });
  return result;
};
